import React from 'react';
import { MultiSelect } from 'components';

const DeviceGroupsSelect = ({ deviceTypes, formData, setFormData, deviceGroups }) => {
  const sysIdx = parseInt(formData?.system_type);
  const devIdx = parseInt(formData?.device_type);

  const selectedType = deviceTypes?.[sysIdx]?.device_types?.[devIdx]?.type;

  const options = (deviceGroups || [])
    .filter((group) => {
      return (
        selectedType === 'Stage' ||
        selectedType === 'Overwatch VMS' ||
        group.type === '' ||
        group.type === selectedType
      );
    })
    .map((group) => ({ name: group.name, value: group.id }));

  return (
    <div className="d-flex flex-column border border-1 p-2 rounded-2 mt-2">
      <MultiSelect
        label="Device Groups"
        options={options}
        value={formData.groups || []}
        onChange={(value) => setFormData({ ...formData, groups: value })}
      />
    </div>
  );
};

export default DeviceGroupsSelect;
